import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { funcState, position2, poolLevelShow, changePoolLevel, lang, normalList, deluxeList } = this.props

    return (
      <div className="reward-pool-main" style={{ display: `${funcState == 6 ? 'block' : 'none'}` }}>
        {/* 模式切换 */}
        <div className="pool-mode">
          <div className="pool-active" style={{ backgroundPosition: `${position2} center` }}></div>
          <div className="pool-txt">
            <div className="low-pool" onClick={() => changePoolLevel(1, true)}>{lang.poolL}</div>
            <div className="hight-pool" onClick={() => changePoolLevel(2, true)}>{lang.poolH}</div>
          </div>
        </div>
        {/* 奖励列表 */}
        <div className="reward-main">
          <div className="rw-bg">
            <div className="rw-list1" style={{ display: `${poolLevelShow == 1 ? 'flex' : 'none'}` }}>
              {
                normalList.map((item, index) => {
                  if (index >= 0 && index < 5) {
                    return (
                      <div className="rw-item" key={index}>
                        <div className="bubble">
                          <img src={item.bubbleUrl} alt="" />
                        </div>
                        <div className="gift">
                          <img src={item.image} style={{ transform: `${item.image.indexOf('egg_fragment') > 0 ? 'scale(0.75)' : ''}` }} />
                        </div>
                        <div className="shadow"></div>
                        <div className="name">{item.name}</div>
                      </div>
                    )
                  }
                })
              }
            </div>
            <div className="rw-list2" style={{ display: `${poolLevelShow == 1 ? 'flex' : 'none'}` }}>
              {
                normalList.map((item, index) => {
                  if (index > 4) {
                    return (
                      <div className="rw-item" key={index}>
                        <div className="bubble">
                          <img src={item.bubbleUrl} alt="" />
                        </div>
                        <div className="gift">
                          <img src={item.image} style={{ transform: `${item.image.indexOf('egg_fragment') > 0 ? 'scale(0.75)' : ''}` }} />
                        </div>
                        <div className="shadow"></div>
                        <div className="name">{item.name}</div>
                      </div>
                    )
                  }
                })
              }
            </div>
            <div className="rw-list1" style={{ display: `${poolLevelShow == 2 ? 'flex' : 'none'}` }}>
              {
                deluxeList.map((item, index) => {
                  if (index >= 0 && index < 5) {
                    return (
                      <div className="rw-item" key={index}>
                        <div className="bubble">
                          <img src={item.bubbleUrl} alt="" />
                        </div>
                        <div className="gift">
                          <img src={item.image} style={{ transform: `${item.image.indexOf('egg_fragment') > 0 ? 'scale(0.75)' : ''}` }} />
                        </div>
                        <div className="shadow"></div>
                        <div className="name">{item.name}</div>
                      </div>
                    )
                  }
                })
              }
            </div>
            <div className="rw-list2" style={{ display: `${poolLevelShow == 2 ? 'flex' : 'none'}` }}>
              {
                deluxeList.map((item, index) => {
                  if (index > 4) {
                    return (
                      <div className="rw-item" key={index}>
                        <div className="bubble">
                          <img src={item.bubbleUrl} alt="" />
                        </div>
                        <div className="gift">
                          <img src={item.image} style={{ transform: `${item.image.indexOf('egg_fragment') > 0 ? 'scale(0.75)' : ''}` }} />
                        </div>
                        <div className="shadow"></div>
                        <div className="name">{item.name}</div>
                      </div>
                    )
                  }
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/gashapon/RewardView/index.js